// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectContainer__d2b {
  display: flex;
  flex-direction: column;
  gap: calc(var(--ring-unit) / 2);
}

.label__a15 {
  display: block;
  color: var(--ring-secondary-color);
  font-size: var(--ring-font-size-smaller);
  line-height: var(--ring-line-height-lowest);
}

.error__e65 {
  margin: 0;
  color: var(--ring-error-color);
  font-size: var(--ring-font-size-smaller);
  line-height: var(--ring-line-height-lowest);
}

.errorBorder__d80 > div > button {
  box-shadow: inset 0 0 0 1px var(--ring-error-color);
}
`, "",{"version":3,"sources":["webpack://./src/common/hook-form/registered-select.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,sBAAsB;EACtB,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,kCAAkC;EAClC,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,SAAS;EACT,8BAA8B;EAC9B,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,mDAAmD;AACrD","sourcesContent":[".selectContainer {\n  display: flex;\n  flex-direction: column;\n  gap: calc(var(--ring-unit) / 2);\n}\n\n.label {\n  display: block;\n  color: var(--ring-secondary-color);\n  font-size: var(--ring-font-size-smaller);\n  line-height: var(--ring-line-height-lowest);\n}\n\n.error {\n  margin: 0;\n  color: var(--ring-error-color);\n  font-size: var(--ring-font-size-smaller);\n  line-height: var(--ring-line-height-lowest);\n}\n\n.errorBorder > div > button {\n  box-shadow: inset 0 0 0 1px var(--ring-error-color);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"selectContainer": `selectContainer__d2b`,
	"label": `label__a15`,
	"error": `error__e65`,
	"errorBorder": `errorBorder__d80`
};
export default ___CSS_LOADER_EXPORT___;
